module.exports = __webpack_public_path__ + "static/media/sun.235a9db5.png";